import GeoCodeService from './GeoCodeService';
import 'ngGMaps';
import 'portalConfig';

export default angular.module('edge.platform.map', ['portal.config', 'ngMap'])
    .service('GeoCodeService', GeoCodeService);
